import { DelayedRequestsPreviewDialogStore } from './delayed-requests-preview-dialog.store';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { OfflineDb } from '../../../../store/offline-db/offline.db';
import { DelayedDbType } from '../../../../store/offline-db/delayed-db/delayed-db.type';
import { translate } from '../../../../modules/shared/shared.global-service';
import { TableColumn, TableColumnType } from '../../../../modules/shared/components/kit/table/table.types';
import { successDeleted } from '../../../../modules/content/content.error';
import { ConfirmBuilder } from '../../../../modules/shared/service/confirm.builder';
import { continueDelayedWork } from '../delayed-requests.util';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-delayed-requests-preview-dialog',
    templateUrl: './delayed-requests-preview-dialog.component.html',
    styleUrl: './delayed-requests-preview-dialog.component.scss',
    providers: [DelayedRequestsPreviewDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TableComponent,

    ],
})
export class DelayedRequestsPreviewDialogComponent extends BaseDialogComponent {

    protected readonly store = inject(DelayedRequestsPreviewDialogStore);
    protected readonly offlineDb = inject(OfflineDb);
    protected readonly confirmBuilder = inject(ConfirmBuilder);

    protected prefix = 'delay-request.';
    protected items: DelayedDbType[] = [];

    protected columns: TableColumn[] = [
        {
            name: 'name',
            dataKey: null,
            data: (item: DelayedDbType) => translate.instant(`${this.prefix}fields.type.${item.resource}.${item.method}`),
        },
        {
            name: 'storedAt',
            type: TableColumnType.DateTime,
            sortable: false,
            filterable: false,
        },
    ];

    constructor() {
        super();
        this.refresh();
    }

    protected async open(item?: DelayedDbType): Promise<void> {
        if (!item) {
            item = this.items?.[0];
        }
        if (!item) return;

        continueDelayedWork(item).then();
        this.dialogRef.close(true);
    }

    protected async delete(event: any): Promise<void> {
        this.confirmBuilder.confirmDelete(
            async () => {
                await this.offlineDb.delayedDb.deleteById(event.item.id);
                successDeleted();
                await this.refresh();
            },
            event,
        );
    }

    private async refresh(): Promise<void> {
        this.items = await this.offlineDb.delayedDb.listAll();
    }

}
